module.exports = __webpack_public_path__ + "img/maintop.95c46e6.png";